import { SubAPI } from "./SubAPI";

export class Teams extends SubAPI {
    // the teams the user is on, the personal one first
    list() {
        return this.fetcher.get<Team[]>("/api/teams");
    }

    // a personal team can't be renamed or archived
    upsert(props: { id?: number; name: string; archived?: boolean }) {
        return this.fetcher.post<Team>("/api/team", props);
    }

    listMembers(props: { team: number }) {
        return this.fetcher.get<TeamMembers>("/api/team-members", props);
    }

    // removes a member, or the user themselves when they leave. A member is only
    // added by invite.
    upsertMember(props: { team: number; usr: number; archived: boolean }) {
        return this.fetcher.post<null>("/api/team-member", props);
    }

    // { team, email } sends an invite, { id, archived: true } cancels one
    upsertInvite(props: { id?: number; team?: number; email?: string; archived?: boolean }) {
        return this.fetcher.post<null>("/api/team-invite", props);
    }

    // readable before login, from the link in the invite email
    getInvite(props: { token: string }) {
        return this.fetcher.get<OpenInvite>("/api/team-invite", props);
    }

    // answers with the id of the team the user joined
    acceptInvite(props: { token: string }) {
        return this.fetcher.post<number>("/api/team-invite/accept", props);
    }
}

export type Team = {
    id: number;
    name: string;
    personal: boolean;
    archived: boolean;
    createdAt: string;
    createdBy: number;
    updatedAt: string;
    memberCount: number;
}

export type TeamMember = {
    usr: number;
    name: string;
    email: string;
    createdAt: string;
}

export type PendingInvite = {
    id: number;
    email: string;
    expiresAt: string;
    createdAt: string;
}

export type TeamMembers = {
    members: TeamMember[];
    invites: PendingInvite[];
}

export type OpenInvite = {
    teamName: string;
    email: string;

    // whether the email can log in, so the page offers log in or create an account
    hasAccount: boolean;
}
